import { ActionsUnion, createAction } from "store/helper";

export enum ApplicationSettingsActionNames {
  FETCH_APPLICATION_SETTINGS_REQUEST = "ENTITIES/APPLICATION_SETTINGS/FETCH_REQUEST",
  FETCH_APPLICATION_SETTINGS_SUCCESS = "ENTITIES/APPLICATION_SETTINGS/FETCH_SUCCESS",
  FETCH_APPLICATION_SETTINGS_FAILURE = "ENTITIES/APPLICATION_SETTINGS/FETCH_FAILURE",
}

export const ApplicationSettingsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch: () => createAction(ApplicationSettingsActionNames.FETCH_APPLICATION_SETTINGS_REQUEST),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  fetchSuccess: (payload: any) =>
    createAction(ApplicationSettingsActionNames.FETCH_APPLICATION_SETTINGS_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  fetchFailure: (payload: any) =>
    createAction(ApplicationSettingsActionNames.FETCH_APPLICATION_SETTINGS_FAILURE, payload),
};

export type ApplicationSettingsAction = ActionsUnion<typeof ApplicationSettingsActions>;
